<template>
  <div class="evidence shadow-sm">
    <div class="row list no-gutters" v-if="evidencesInitial(value).length > 0">
      <div class="item item-last col">
        <a class="py-2 px-3"><strong class="mr-2">{{ $t('initial') }}</strong></a>
      </div>
    </div>
    <div
      v-for="e in evidencesInitial(value)"
      :key="`evidence-${e.id}`"
      class="row list no-gutters"
    >
      <div class="col item">
        <a class="py-2 px-3" v-if="e.id">
          {{ e.name[authLocale] }}
        </a>
      </div>
      <div class="col-auto item item-last">
        <a class="py-2 px-3 pointer" @click.prevent="deleteEvidence(e.id)">
          <span class="text-primary">
            <remove-icon></remove-icon>
          </span>
        </a>
      </div>
    </div>
    <div class="row list no-gutters" v-if="evidencesFeatured(value).length > 0">
      <div class="item item-last col">
        <a class="py-2 px-3"><strong class="mr-2">{{ $t('featured') }}</strong></a>
      </div>
    </div>
    <div
      v-for="e in evidencesFeatured(value)"
      :key="`evidence-${e.id}`"
      class="row list no-gutters"
    >
      <div class="col-auto item">
        <a class="py-2 px-3 h-100">
          <span class="text-success" v-if="e.choice === 'present'">
            <yes-icon></yes-icon>
          </span>
          <span class="text-danger" v-else>
            <no-icon></no-icon>
          </span>
        </a>
      </div>
      <div class="col item">
        <a class="py-2 px-3" v-if="e.id">
          {{ e.name[authLocale] }}
        </a>
      </div>
      <div class="col-auto item item-last">
        <a class="py-2 px-3 pointer" @click.prevent="deleteEvidence(e.id)">
          <span class="text-primary">
            <remove-icon></remove-icon>
          </span>
        </a>
      </div>
    </div>
    <div class="row list no-gutters" v-if="evidencesPresent(value).length > 0">
      <div class="item item-last col">
        <a class="py-2 px-3"><strong class="mr-2">{{ $t('present') }}</strong></a>
      </div>
    </div>
    <div
      v-for="e in evidencesPresent(value)"
      :key="`evidence-${e.id}`"
      class="row list no-gutters"
    >
      <div class="col-auto item">
        <a class="py-2 px-3 h-100">
          <span class="text-success">
            <yes-icon></yes-icon>
          </span>
        </a>
      </div>
      <div class="col item">
        <a class="py-2 px-3" v-if="e.id">
          {{ e.name[authLocale] }}
        </a>
      </div>
      <div class="col-auto item item-last">
        <a class="py-2 px-3 pointer" @click.prevent="deleteEvidence(e.id)">
          <span class="text-primary">
            <remove-icon></remove-icon>
          </span>
        </a>
      </div>
    </div>
    <div class="row list no-gutters" v-if="evidencesAbsent(value).length > 0">
      <div class="item item-last col">
        <a class="py-2 px-3"><strong class="mr-2">{{ $t('absent') }}</strong></a>
      </div>
    </div>
    <div
      v-for="e in evidencesAbsent(value)"
      :key="`evidence-${e.id}`"
      class="row list no-gutters"
    >
      <div class="col-auto item">
        <a class="py-2 px-3 h-100">
          <span class="text-success" v-if="e.choice === 'present'">
            <yes-icon></yes-icon>
          </span>
          <span class="text-danger" v-else>
            <no-icon></no-icon>
          </span>
        </a>
      </div>
      <div class="col item">
        <a class="py-2 px-3" v-if="e.id">
          {{ e.name[authLocale] }}
        </a>
      </div>
      <div class="col-auto item item-last">
        <a class="py-2 px-3 pointer" @click.prevent="deleteEvidence(e.id)">
          <span class="text-primary">
            <remove-icon></remove-icon>
          </span>
        </a>
      </div>
    </div>
    <div class="list">
      <div class="item item-last item-bottom">
        <a class="py-3 px-3 pointer text-primary" @click.prevent="showSymptoms = !showSymptoms">
          <strong :class="{closed: !showSymptoms, open: showSymptoms}">
            <small>
              <plus-icon v-if="!showSymptoms"></plus-icon>
              <minus-icon v-else></minus-icon>
            </small>
            {{ $t("addSymptom") }}
          </strong>
        </a>
      </div>
    </div>
    <div class="list row no-gutters" v-show="showSymptoms">
      <div class="item item-last col">
        <a>
          <input type="text" class="w-100 px-3 py-2" v-model="keyword" :placeholder="$t('searchSymptoms')">
        </a>
      </div>
    </div>
    <div class="evidence-list border-bottom" v-show="showSymptoms">
      <div
        class="list row no-gutters"
        v-for="evidence of evidencesForSelect"
        :key="`symptom-${evidence.id}`"
      >
        <div class="item col-auto">
          <a class="text-success py-2 px-3 h-100 pointer" @click.prevent="addEvidence(evidence.id, 'present')">
            <yes-icon></yes-icon>
          </a>
        </div>
        <div class="item col-auto">
          <a class="text-danger py-2 px-3 h-100 pointer" @click.prevent="addEvidence(evidence.id, 'absent')">
            <no-icon></no-icon>
          </a>
        </div>
        <div class="item item-last col">
          <a class="py-2 px-3" v-if="evidence">
            {{ evidence.name[authLocale] }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
import PlusIcon from '@/components/Icons/Plus'
import MinusIcon from '@/components/Icons/Minus'
import RemoveIcon from '@/components/Icons/Remove'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    YesIcon,
    NoIcon,
    PlusIcon,
    MinusIcon,
    RemoveIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      evidence: null,
      fetchedEvidences: [],
      keyword: null,
      showSymptoms: false,
      searching: false
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      authUser: 'auth/user',
      caseById: 'pcase/byId',
      evidences: 'pcase/evidences',
      evidencesPresent: 'pcase/evidencesPresent',
      evidencesAbsent: 'pcase/evidencesAbsent',
      evidencesInitial: 'pcase/evidencesInitial',
      evidencesFeatured: 'pcase/evidencesFeatured',
      patientGender: 'pcase/patientGender',
      patientAge: 'pcase/patientAge'
    }),
    evidencesForSelect () {
      const ret = []
      const eIds = {}
      for (const e of this.evidences(this.value)) {
        eIds[e.id] = true
      }
      for (const val of this.fetchedEvidences) {
        if (eIds[val.id]) {
          continue
        }
        ret.push({
          id: val.id,
          name: val.name,
          common_name: val.common_name
        })
      }
      return ret
    }
  },
  watch: {
    keyword (query) {
      this.fetchedEvidences = []
      if (this.searching) {
        clearTimeout(this.searching)
      }
      this.searching = setTimeout(this.searchSymptomsAjax(query), 500)
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      pushEvidence: 'pcase/pushEvidence',
      removeEvidence: 'pcase/removeEvidence'
    }),
    searchSymptomsAjax (query) {
      return async () => {
        if (!query) {
          return
        }
        try {
          const patientAge = this.patientAge(this.value)
          const params = {
            language: this.authLocale,
            gender: this.patientGender(this.value),
            age: patientAge.value,
            age_unit: patientAge.unit,
            keyword: query
          }
          const response = await this.axios.get('/api/search/evidences', {
            params
          })
          this.fetchedEvidences = response.data.data
          //   this.isLoading = false
        } catch (err) {
          this.setError(err)
          //   this.isLoading = false
        }
        // this.error = ''
        // this.axios.get('/symptom/api/symptoms/search?query=' + query + '&gender=' + this.gender)
        //   .then(this.setSymptoms)
        //   .catch(function (error) {
        //     console.error(error)
        //   })
      }
    },
    async addEvidence (evidenceId, choice) {
      try {
        const params = {
          evidence_id: evidenceId,
          choice_id: choice
        }
        const response = await this.axios.post(
          `/api/patient-cases/${this.value}/evidences`,
          params
        )
        this.pushEvidence({ id: this.value, evidence: response.data.data })
      } catch (err) {
        this.setError(err)
      }
      this.evidence = null
    },
    async deleteEvidence (evidenceId) {
      try {
        const params = {
          evidence_id: evidenceId
        }
        await this.axios.post(`/api/patient-cases/${this.value}/evidences/remove`, params)
        this.removeEvidence({ id: this.value, evidenceId: evidenceId })
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.evidence {
  .evidence-list {
    max-height: 400px;
    overflow: auto;
  }
}
</style>
<i18n>
{
  "ka": {
    "addSymptom": "სიმპტომის დამატება",
    "searchSymptoms": "სიმპტომის ძიება",
    "initial": "საწყისი ჩივილები",
    "present": "ფიქსირდება",
    "absent": "არ ფიქსირდება",
    "featured": "მნიშვნელოვანი"
  },
  "en": {
    "addSymptom": "Add Evindence",
    "searchSymptoms": "Search Evidence",
    "initial": "Inital Symptoms",
    "present": "Present",
    "absent": "Absent",
    "featured": "Featured"
  }
}
</i18n>
